module.exports = __webpack_public_path__ + "media/desk.9b78d76b.mp4";